import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import BluebirdPromise from 'bluebird';
import { ProgressBar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FullPageContent from '../../../shared/components/FullPageContent';
import Page from '../../../shared/components/Page';
import VerbHeading from '../../../shared/components/VerbHeading';
import CollectionContainer from './CollectionContainer';
import { calculatePercentage } from '../../../shared/utils/NumberUtils';
import FullPageLoadingIndicator from '../../../shared/components/FullPageLoadingIndicator';
import {
    getUserLearningAsset,
    getLearningAssetRecommended,
    getManyTeams,
    getManyUserPathways,
    getManyUserCollections,
} from '../../../shared/actions';
import { RuntimeContext } from '../../../..//common/RuntimeContext';

class TakeActionActivityInterstitial extends Component {
    static propTypes = {
        match: PropTypes.object,
        currentUserLearningAsset: PropTypes.object,
        getUserLearningAsset: PropTypes.func,
        getLearningAssetRecommended: PropTypes.func,
        loggedInUser: PropTypes.object,
        getManyTeams: PropTypes.func,
        loggedInUserCompany: PropTypes.object,
        isVerbAdmin: PropTypes.bool,
        currentUserPathway: PropTypes.object,
        getManyUserPathways: PropTypes.func,
        getManyUserCollections: PropTypes.func,
        userCollectionsById: PropTypes.object,
        userPathwaysById: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            interstitialData: {
                assetIsInUserCollection: false,
                totalAssets: 0,
                totalComplete: 0,
                nextLearningAsset: {},
                currentCollection: {},
                currentUserCollection: {}
            },
            forcedRecommendation: false
        };
    }

    static contextType = RuntimeContext;

    componentDidMount() {
        const { match, loggedInUser } = this.props;
        return this._getData(match.params.userLearningAssetId).then(this._checkLastRecommendedModalAlert);
    }

    componentDidUpdate(prevProps) {
        const { match, loggedInUser } = this.props;
        if (!prevProps.loggedInUser?._id && loggedInUser?._id) {
            return this._getData(match.params.userLearningAssetId).then(this._checkLastRecommendedModalAlert);
        }
        return null;
    }

    _getData = (userLearningAssetId) => {
        const {
            getUserLearningAsset,
            getLearningAssetRecommended,
            getManyTeams,
            loggedInUser,
            getManyUserPathways,
            getManyUserCollections,
            userCollectionsById,
            userPathwaysById
        } = this.props;
        this.setState({ loading: true });
        if (loggedInUser._id) {
            const promises = [
                getManyTeams({ pathsContext: this.context.pathsWeb }),
                getLearningAssetRecommended({ userLearningAssetId, pathsContext: this.context.pathsWeb }).then(
                    (interstitialData) => {
                        this.setState({
                            interstitialData
                        });
                    }
                ),
                getUserLearningAsset({ userLearningAssetId, pathsContext: this.context.pathsWeb })
            ];

            if (isEmpty(userCollectionsById)) {
                promises.push(
                    getManyUserCollections({ userProfileId: loggedInUser._id, pathsContext: this.context.pathsWeb })
                );
            }

            if (isEmpty(userPathwaysById)) {
                promises.push(
                    getManyUserPathways({ userProfileId: loggedInUser._id, pathsContext: this.context.pathsWeb })
                );
            }

            return BluebirdPromise.all(promises).then(() =>
                this.setState({
                    loading: false
                })
            );
        }
        return null;
    };

    render() {
        const { currentUserLearningAsset, currentUserPathway } = this.props;
        const {
            interstitialData: {
                currentCollection,
                currentUserCollection,
                totalCollectionAssets,
                totalCollectionAssetsComplete
            },

            loading
        } = this.state;
        const contentLength = currentUserCollection?.content?.length || 0;
        if (!contentLength) {
            return null;
        }
        const nextAssetId = currentUserCollection?.content[contentLength - 2]?.userLearningAssetId;
        const progress = calculatePercentage(totalCollectionAssetsComplete, totalCollectionAssets);
        const headingDefaultMessage = "Congrats on your commitment to improving your skills!";
        if (loading) {
            return (
                <Page className={'asset-interstitial-experimental'}>
                    <FullPageContent>
                        <FullPageLoadingIndicator />
                    </FullPageContent>
                </Page>
            );
        }
        return (
            <Page className={'asset-interstitial-experimental'}>
                <FullPageContent className={'asset-interstitial-page take-action-intersititial'}>
                    <div className={'take-action-interstitial-heading container'}>
                        <VerbHeading
                            hNumber={3}
                            messageId={'TAKE_ACTION_INTERSTITIAL_HEADING'}
                            defaultMessage={headingDefaultMessage}
                            className={'verb-title-align-center'}
                        />
                        <p className={'verb-title-align-center take-action-interstitial-subtitle'}>
                            After doing your <Link to={`/workspace/${nextAssetId}?takeActionReroute=true`}>small action</Link>, come back to complete this Path.
                        </p>
                        <div className={'col-12'}>
                            <div className={'collection-progress-bar-container'}>
                                <VerbHeading
                                    className={'progress-bar-label'}
                                    messageId={'ASSET_INTERSTITIAL_COLLECTION_PROGRESS_TEXT'}
                                    hNumber={6}
                                    defaultMessage={'PATH PROGRESS'}
                                />
                                <ProgressBar now={progress} />
                            </div>
                        </div>
                    </div>
                    <CollectionContainer
                        collection={currentCollection}
                        userCollection={currentUserCollection}
                        totalCollectionAssets={totalCollectionAssets}
                        totalCollectionAssetsComplete={totalCollectionAssetsComplete}
                        currentUserPathway={currentUserPathway}
                        hideCollectionProgress
                    />
                </FullPageContent>
            </Page>
        );
    }
}

export const makeMapStateToProps = () => {
    const mapStateToProps = (state, ownProps) => {
        const {
            auth: { loggedInUser, loggedInUserCompanyId, isAccountOwner, isVerbAdmin },
            userLearningAssets,
            userCollections = {},
            companies,
            behaviors,
            teams,
            userPathways = {}
        } = state;

        const {
            match: { params }
        } = ownProps;
        const currentUserLearningAsset = userLearningAssets.byId[params.userLearningAssetId] || {};
        const loggedInUserCompany = companies.byId && companies.byId[loggedInUserCompanyId];

        let currentUserPathway;

        const associatedUserCollectionIdDict = {};

        Object.values(userCollections.byId).forEach((userCollection) => {
            userCollection.content.forEach((contentItem) => {
                if (contentItem.userLearningAssetId === currentUserLearningAsset._id) {
                    associatedUserCollectionIdDict[userCollection._id] = true;
                }
            });
        });

        const allUserPathways = Object.values(userPathways.byId); // this is already sorted by createdOn desc

        for (let i = 0; i < allUserPathways.length; i += 1) {
            for (let j = 0; j < allUserPathways[i].content.length; j += 1) {
                const contentItem = allUserPathways[i].content[j];
                if (associatedUserCollectionIdDict[contentItem.userSubscriptionId]) {
                    currentUserPathway = allUserPathways[i];
                    break;
                }
            }
        }

        return {
            loggedInUser,
            currentUserLearningAsset,
            behaviors: behaviors.byId,
            isVerbAdmin,
            isAccountOwner,
            loggedInUserCompany,
            teamsById: teams.byId,
            currentUserPathway,
            userCollectionsById: userCollections.byId,
            userPathwaysById: userPathways.byId
        };
    };
    return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
    getUserLearningAsset: (params) => dispatch(getUserLearningAsset(params)),
    getLearningAssetRecommended: (params) => dispatch(getLearningAssetRecommended(params)),
    getManyTeams: (params) => dispatch(getManyTeams(params)),
    getManyUserPathways: (params) => dispatch(getManyUserPathways(params)),
    getManyUserCollections: (params) => dispatch(getManyUserCollections(params))
});

export const TakeActionActivityInterstitialV2Component = TakeActionActivityInterstitial;
export default connect(makeMapStateToProps, mapDispatchToProps)(TakeActionActivityInterstitial);
